import * as React from 'react';
import { ChangeEvent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { SearchField } from '../Form/SearchField';
import { FilterViewProps } from './FilterViewProps';

export class SearchTermFilter<T extends JobCenterModelInterface> extends React.Component<FilterViewProps<T>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: FilterViewProps<T>, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        return <SearchField value={this.props.filterSettings.searchTerm || ''}
                            onChange={this.handleChange}
                            placeholder={this.context.i18n.translate("Suchbegriff eingeben")}/>;
    }

    private handleChange(value: string, _event: ChangeEvent<HTMLInputElement>) {
        const props = this.props;

        props.onChange(props.filterSettings.withSearchTerm(value.trim()));
    }
}
